module.exports = "<div class=\"inmodal\">\n  <div class=\"color-line\"></div>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">Remind</h4>\n  </div>\n  <div class=\"modal-body\">\n    <p>Remind <strong>{{$ctrl.items.length}}</strong> timesheet(s).</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.ok()\">Ok</button>\n    <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n  </div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/review/modals/remind/template.html
// module id = 1000
// module chunks = 0